import { CHECK_CURRENT_TREND_CHART_BARS_INTERVAL } from "constants/intervals";
import { useState } from "react";
import { useInterval } from "react-use";
import {
  useFocusRange,
  useGetPageFromPath,
} from "utils/customHooks/genericHooks";

/**if it's a current time range, return a random key to force refetch on interval */
export function useForceRerenderOnIntervalIfCurrentRange() {
  const focusRange = useFocusRange();
  const [randKey, setRandKey] = useState(Math.random());
  const { isTier0Page } = useGetPageFromPath();
  useInterval(() => {
    const now = Date.now();
    const isCurrentFocusRange =
      focusRange && focusRange.ge <= now && focusRange.lt > now;
    if (isCurrentFocusRange || isTier0Page) {
      setRandKey(Math.random());
    }
  }, CHECK_CURRENT_TREND_CHART_BARS_INTERVAL);
  return randKey;
}
